import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import {Box, Card, CardContent, Grid, Typography} from '@mui/material';
import {motion} from 'framer-motion';

export default function LandingComingSoon() {
  const comingSoonFeatures = [
    'Bulk item uploads with draft listing as templates.',
    'A dedicated space for your suggestions & feedback.',
    'A newsletter with tips & updates.',
    // 'Order alerts so you never miss a sale.',
    // 'Print delivery notes for faster order processing.',
  ];

  return (
    <Box
      component={motion.div}
      initial={{opacity: 0}}
      whileInView={{opacity: 1}}
      transition={{duration: 0.8}}
      viewport={{once: true}}
    >
      <Typography variant="h2" gutterBottom>
        🚀 What&apos;s Coming Next
      </Typography>
      <Grid container spacing={3}>
        {comingSoonFeatures.map((feature) => (
          <Grid size={{xs: 12, sm: 6, md: 4}} key={`LandingComingSoon-${feature}`}>
            <Card component={motion.div} whileHover={{scale: 1.05}} transition={{duration: 0.2}}>
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <RocketLaunchIcon color="secondary" sx={{mr: 1}} />
                  <Typography variant="h6" component="div">
                    Coming Soon
                  </Typography>
                </Box>
                <Typography variant="body2">{feature}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
